import React from 'react';
const HeaderLogo = ({title}) => {
  return (
    <div className="tcc-header">
      <div className="tcc-header-logo">
        <img
          height="80"
          src={`${process.env.PUBLIC_URL}/media/tcc-logo.jpg`}
          alt="toyota certificacióxn como nuevo logo"
        />
        <h2 className="tcc-header-logo-title">{title}</h2>
      </div>
    </div>
  );
};

export default HeaderLogo;
